import Reveal from "@/components/Reveal";

const points = [
  ["Rep", "Summary, customer commitments, reminders and next steps"],
  ["Manager", "Call quality, intent, objections and missed opportunities"],
  ["Organisation", "Recurring buyer concerns, competitor signals and knowledge gaps"],
];

const metrics = [
  ["Discovery coverage", 78],
  ["Objection handling", 91],
  ["Next-step clarity", 74],
];

export default function Progress() {
  return (
    <section className="progress" id="progress" data-testid="progress-section">
      <div className="wrap">
        <article className="phase">
          <div className="phase-grid">
            <div>
              <div className="label mono">Progress</div>
              <h3>Every call ends with clear follow-through</h3>
              <p>
                ThinkWire captures the conversation for the rep, surfaces coaching evidence for the
                manager and preserves recurring buyer intelligence for the organisation.
              </p>
              <div className="phase-points">
                {points.map(([k, v]) => (
                  <div className="phase-point" key={k}>
                    <strong>{k}</strong>
                    <span>{v}</span>
                  </div>
                ))}
              </div>
            </div>

            <Reveal className="progress-ui" data-testid="progress-ui">
              <article className="summary-card">
                <div className="card-label">Completed call · auto summary</div>
                <h4>Price concern resolved. Site visit proposed.</h4>
                <p>
                  John accepted the long-term value comparison and wants to review Unit B-1406 with
                  his spouse before confirming Saturday.
                </p>
                <div className="summary-list">
                  <div className="summary-row">
                    <strong>Commitment</strong>
                    <span>Review the payment plan tonight</span>
                  </div>
                  <div className="summary-row">
                    <strong>Follow-up</strong>
                    <span>Confirm Saturday site visit tomorrow</span>
                  </div>
                  <div className="summary-row">
                    <strong>Buyer signal</strong>
                    <span>High intent. Price sensitivity remains.</span>
                  </div>
                </div>
              </article>

              <article className="manager-card">
                <div className="manager-top">
                  <div>
                    <div className="card-label">Manager assessment</div>
                    <div style={{ fontSize: 12, marginTop: 7 }}>John Doe · 08:21</div>
                  </div>
                  <div className="score">
                    82<small>/100</small>
                  </div>
                </div>
                {metrics.map(([label, value]) => (
                  <div className="metric" key={label}>
                    <div className="metric-head">
                      <span>{label}</span>
                      <span>{value}%</span>
                    </div>
                    <div className="metric-track">
                      <i style={{ width: `${value}%` }} />
                    </div>
                  </div>
                ))}
                <div className="coaching">
                  <small>Coaching priority</small>
                  <p>Confirm every decision-maker before proposing the next meeting.</p>
                </div>
              </article>
            </Reveal>
          </div>
        </article>
      </div>
    </section>
  );
}
